import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/comics';

function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-xl font-bold text-background-50 mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors">
                韩漫之家
              </Link>
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="QQ" rel="nofollow">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4 uppercase tracking-wider">
              <Link to="/category/romance">漫画分类</Link>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4 uppercase tracking-wider">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  版权声明
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4 uppercase tracking-wider">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-primary-400"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-wechat-line text-primary-400"></i>
                <span>微信：{siteInfo.wechat}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-weibo-line text-primary-400"></i>
                <span>{siteInfo.weibo}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 韩漫之家 版权所有 | 本站所有漫画内容仅供学习交流使用
          </p>
          <p className="text-xs text-background-600">
            韩漫大全 · 高清韩国漫画 · 免费韩漫在线阅读
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;